import { render, staticRenderFns } from "./ButtonsEdit.vue?vue&type=template&id=09972eb2&scoped=true&"
import script from "./ButtonsEdit.vue?vue&type=script&lang=js&"
export * from "./ButtonsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09972eb2",
  null
  
)

export default component.exports